import InputAutocompleteLocation from './InputAutocompleteLocation.component';
export { default as InputAutocompleteLocationField } from './InputAutocompleteLocationField.component';

export default InputAutocompleteLocation;
